import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';
import ChangeCourseModal from './ChangeCourseModal';

/**
 * Trigger button + modal for the CRM Course Change wizard. Normalises the raw
 * datagrid row (field names differ between the CRM and Batch registers) into the
 * shape ChangeCourseModal expects.
 *
 * @param {object}   props.row      Raw datagrid row.
 * @param {('crm'|'batch')} props.source
 * @param {function} props.onSuccess  Called after a successful migration (refresh the grid).
 */
export default function ChangeCourseAction({ row, source = 'crm', onSuccess }) {
  const [open, setOpen] = useState(false);

  const enrollment =
    source === 'batch'
      ? {
          courseEnrollmentId: row?.course_enrollment_id,
          studentName: row?.studentName,
          admissionNo: row?.admissionNo,
          courseName: row?.courseName,
          deliveryModel: row?.batchName || row?.course_batch_name ? 'Batch (Group)' : 'Single (1-1)',
          completedSessions: row?.sessions_completed,
          totalSessions: row?.total_sessions,
          tutorName: row?.trainer_name || row?.assigned_tutor || '-',
          croName: row?.croName,
        }
      : {
          courseEnrollmentId: row?.course_enrollment_id,
          studentName: row?.student_name,
          admissionNo: row?.admn_no,
          courseName: row?.course_name,
          deliveryModel: row?.course_batch_name ? 'Batch (Group)' : 'Single (1-1)',
          completedSessions: row?.sessions_completed,
          totalSessions: row?.total_sessions,
          tutorName: row?.trainer_name || row?.assigned_tutor || '-',
          croName: row?.croName,
        };

  // Active-enrollment gate (course_enrollment_status / admission_status === 1,
  // or for the batch register an empty inactiveTimestamp).
  const isActive =
    source === 'batch'
      ? !row?.inactiveTimestamp
      : row?.admission_status === 1 || row?.course_enrollment_status === 1;

  return (
    <>
      <Tooltip title={isActive ? '' : 'Available only for active enrollments'}>
        <span>
          <Button
            size="small"
            variant="outlined"
            color="secondary"
            disabled={!isActive}
            startIcon={<Icon icon="material-symbols-light:swap-horiz-rounded" width={18} height={18} />}
            onClick={() => setOpen(true)}
          >
            Change Course
          </Button>
        </span>
      </Tooltip>
      {open ? (
        <ChangeCourseModal enrollment={enrollment} open={open} setOpen={setOpen} onSuccess={onSuccess} />
      ) : null}
    </>
  );
}
